// extracted by mini-css-extract-plugin
module.exports = {"postfix":"b13981c874--postfix--byxwX"};